<template>
  <v-form ref="form">
    <v-row class="mt-2">
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          id="inputQuantity"
          v-model="couponData.quantity"
          :label="$t('sales.discount-coupon.tickets-quantity')"
          :placeholder="$t('sales.discount-coupon.insert-quantity')"
          :rules="[rules.required]"
          type="number"
        >
          <template v-slot:append-outer>
            <ToolTip
              :text="$t('sales.discount-coupon.tickets-quantity-tooltip')"
            />
          </template>
        </BaseTextField>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          v-model="couponData.useLimit"
          :label="$t('sales.discount-coupon.limit-per-consumer')"
          :placeholder="
            $t('sales.discount-coupon.insert-quantity-per-consumer')
          "
          :rules="[rules.required]"
        >
          <template v-slot:append-outer>
            <ToolTip
              :text="$t('sales.discount-coupon.limit-per-consumer-tooltip')"
            />
          </template>
        </BaseTextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <BaseSelect
          v-model="discountType"
          :label="$t('sales.discount-coupon.discount-type')"
          :placeholder="$t('sales.discount-coupon.select-discount-type')"
          :items="discountTypeOptions"
          :rules="[rules.required]"
          @input="clearDiscountFields"
          item-text="text"
          item-value="value"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseMoneyField
          v-if="discountType === 'value'"
          v-model="couponData.discountValue"
          :label="$t('sales.discount-coupon.discount-value')"
          :placeholder="$t('sales.discount-coupon.insert-discount-value')"
          :options="optionsCurrency"
          :rules="[rules.required, rules.requiredPrice]"
        >
          <template v-slot:append-outer>
            <ToolTip
              :text="$t('sales.discount-coupon.discount-value-tooltip')"
            />
          </template>
        </BaseMoneyField>
        <BaseMoneyField
          v-else
          v-model="couponData.discountPercentage"
          :label="$t('sales.discount-coupon.discount-percentage')"
          :placeholder="$t('sales.discount-coupon.insert-discount-percentage')"
          :options="optionsPercent"
          :rules="[rules.required, rules.requiredPrice]"
        >
          <template v-slot:append-outer>
            <ToolTip
              :text="$t('sales.discount-coupon.discount-percentage-tooltip')"
            />
          </template>
        </BaseMoneyField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <BaseMoneyField
          v-if="discountType === 'value'"
          v-model="couponData.minOrderValue"
          :label="$t('sales.discount-coupon.min-order-value')"
          :placeholder="$t('sales.discount-coupon.insert-min-order-value')"
          :options="optionsCurrency"
          :rules="[rules.required, rules.requiredPrice]"
        >
          <template v-slot:append-outer>
            <ToolTip
              :text="$t('sales.discount-coupon.min-order-value-tooltip')"
            />
          </template>
        </BaseMoneyField>
        <BaseMoneyField
          v-else
          v-model="couponData.maxDiscount"
          :label="$t('sales.discount-coupon.max-discount')"
          :placeholder="$t('sales.discount-coupon.insert-max-discount')"
          :options="optionsCurrency"
          :rules="[rules.required, rules.requiredPrice]"
        >
          <template v-slot:append-outer>
            <ToolTip :text="$t('sales.discount-coupon.max-discount-tooltip')" />
          </template>
        </BaseMoneyField>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import CupomMixins from "@/mixins/Cupom.mixins.js";
import formRules from "../../../mixins/formRules";
import BaseTextField from "../../forms/BaseTextField.vue";
import BaseSelect from "../../forms/BaseSelect.vue";
import BaseMoneyField from "../../forms/BaseMoneyField.vue";
import ToolTip from "./ToolTip.vue";

export default {
  name: "PricesAndDiscounts",
  mixins: [CupomMixins, formRules],
  components: {
    BaseTextField,
    BaseSelect,
    BaseMoneyField,
    ToolTip,
  },
  data() {
    return {
      discountType: "value",
      optionsCurrency: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      optionsPercent: {
        locale: "pt-BR",
        prefix: "%",
        suffix: "",
        length: 2,
        precision: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["couponData"]),
    discountTypeOptions() {
      return [
        { text: this.$t("sales.discount-coupon.value"), value: "value" },
        {
          text: this.$t("sales.discount-coupon.percentage"),
          value: "percentage",
        },
      ];
    },
    isEdit() {
      return this.$route.path == "/cupom-desconto/editar";
    },
  },
  watch: {
    discountType() {
      this.couponData.discountType = this.discountType;
    },
  },
  methods: {
    clearDiscountFields() {
      this.couponData.discountPercentage = 0;
      this.couponData.discountValue = 0;
      this.couponData.maxDiscount = 0;
      this.couponData.minOrderValue = 0;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.discountType = this.couponData.discountType;
    }
  },
};
</script>

<style lang="scss" scoped></style>
